// Kept identical to BLOCKED_WEBSITE_DOMAINS in app/utils/url_filters.py, which
// is the enforcing gate — this copy only gives the user immediate feedback.
// A backend test asserts the two lists match, so add to both or neither.
export const BLOCKED_DOMAINS = [
  'facebook.com',
  'fb.com',
  'fb.me',
  'linkedin.com',
  'instagram.com',
  'twitter.com',
  'x.com',
  'issuu.com',
  'scribd.com',
  'slideshare.net',
  'flipsnack.com',
  // A site builder's editor is a private backend, never a public page.
  'editor.wix.com',
]

export function isBlockedUrl(url: string): boolean {
  try {
    const normalised = url.startsWith('http') ? url : `https://${url}`
    const hostname = new URL(normalised).hostname.toLowerCase()

    return BLOCKED_DOMAINS.some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
    )
  } catch {
    return false
  }
}

export function getBlockedUrlMessage(): string {
  return (
    "This site can't be read. Social media, login-required sites, and document hosting platforms are not supported. " +
    'You can upload documents as files instead or add any missing information in the next step.'
  )
}
